<template>
  <div>
    <div class="row">
      <div class="col-sm-8 no-padding-left">
        <multiselect
          v-model="empresaSelecionada"
          :option-height="130"
          @select="getEmpresaInfo"
          @search-change="setFts"
          @keyup.enter.native="search"
          :options="empresas"
          :internal-search="false"
          :allow-empty="false"
          track-by="id"
          label="fantasia"
          placeholder="Use ID ou Fantasia e pressione Enter."
          selectLabel="Selecionar"
          selectedLabel="Selecionado"
          deselect-label
        >
          <div slot="noResult">
            <i
              style="font-size: 10px; margin-right: 3px;"
              :class="{
                'el-icon-loading': isLoading
              }"
            ></i>
            <span v-if="isLoading"> Carregando... </span>
            <span v-else> Nenhum resultado encontrado! </span>
          </div>
          <div slot="option" slot-scope="props">
            <p>ID: {{ props.option.id }}</p>
            <p>{{ props.option.fantasia }}</p>
            <p>{{ props.option.razaoSocial }}</p>
            <p>{{ props.option.cnpj | cpfCnpj }}</p>
          </div>
        </multiselect>
      </div>
      <div class="hidden-when-reaches-minwidth">
        <toggle-button
          class="pull-left"
          style="margin: 10px 10px 0 0;"
          :disabled="isLoading"
          :value="this.empresaSelecionada.ativo"
          @change="onChangeSituacao"
          :width="60"
          :color="{ checked: '#00A65A', unchecked: '#DD4B39' }"
          :sync="true"
          :labels="{ checked: 'Ativa', unchecked: 'Inativa' }"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import EmpresaService from '../services/EmpresaService'
import Modal from './Modal.vue'
import EmpresaDetalhes from '../app/Empresas/EmpresaDetalhes.vue'
import EmpresaPendencias from '../app/Empresas/EmpresaPendencias.vue'
import Permissions from '../models/Permissions'

export default {
  name: 'selecao-empresa',
  data() {
    return {
      paramsSeachCompany: {
        idEmpresa: null,
        cpfCnpj: null,
        fts: null,
        idUsuario: null
      },
      isAtiva: true,
      empresas: [],
      modalDetalhes: false,
      permissions: Permissions,
      isLoading: false,
      searchInput: ''
    }
  },
  mounted() {},
  methods: {
    setFts(value) {
      if (value !== this.searchInput.fts) this.empresas = []
      this.searchInput = value
    },

    async search() {
      if (!this.searchInput || !this.searchInput.trim()) return
      this.isLoading = true
      this.selectTypeSearchCompany(this.searchInput)
      try {
        await this.checkIfCompanyIsReferenced(this.paramsSeachCompany)
        const { body } = await EmpresaService.pesquisaSimplesEmpresa(this.paramsSeachCompany)
        this.empresas = body
      } catch (e) {
        this.resetInputsSeach()
        this.$messages
          .error(e.message || e.data.message)
          .toast('Não foi possível buscar as empresas.')
        console.error(e)
      } finally {
        this.isLoading = false
      }
    },

    async checkIfCompanyIsReferenced({ idEmpresa = '', cpfCnpj = '' }) {
      if (!idEmpresa && !cpfCnpj) return
      try {
        const { data: [data] = {} } = await EmpresaService.checkIfCompanyIsReferenced({
          cpfCnpj,
          idEmpresa,
          idUsuario: this.usuarioLogado.basic.idUsuario
        })
        if (!data.empresaReferenciada && data.idEmpresa)
          await this.makeReference({ idEmpresa: data.idEmpresa, idUsuario: data.idUsuario })
        if (!data.empresaReferenciada && !data.idEmpresa) this.goToRegister(data.cpfCnpj)
      } catch (e) {
        this.$messages
          .error(e.message || e.data.message)
          .toast('Não foi possível verificar a referência da empresa.')
        console.error(e)
      }
    },

    async makeReference({ idEmpresa, idUsuario }) {
      try {
        await EmpresaService.makeReference({ idEmpresa, idUsuario })
      } catch (e) {
        this.$messages
          .error(e.message || e.data.message)
          .toast('Não foi possível referenciar a empresa.')
        console.error(e)
      }
    },

    goToRegister(cpfCnpj) {
      this.$router.push({ path: '/empresa/new/register' })
      setTimeout(async () => {
        const input = document.querySelector('#__ncm_input_cnpj')
        input.value = cpfCnpj
        input.dispatchEvent(new Event('keyup'))
        const btn = document.querySelector('#searchCnpjReceita')
        btn.click()
      }, 400)
      this.$messages.info().toast('É necessário cadastrar a empresa !')
    },

    resetInputsSeach() {
      this.searchInput = ''
      this.paramsSeachCompany = {
        idEmpresa: null,
        cpfCnpj: null,
        fts: null,
        idUsuario: null
      }
    },

    async onChangeSituacao() {
      this.empresaSelecionada.ativo = !this.empresaSelecionada.ativo

      try {
        const response = await EmpresaService.updateEmpresaAtivo({
          ativo: this.empresaSelecionada.ativo,
          idEmpresa: this.empresaSelecionada.id
        })

        await this.getEmpresaInfo(this.empresaSelecionada)

        const status = this.empresaSelecionada.ativo ? 'ativada' : 'desativada'
        this.$messages.success(response.data.message).toast(`Empresa ${status} com sucesso!`)
      } catch (e) {
        this.$messages
          .error(e.message || e.data.message)
          .toast('Não foi possível atualizar o status da empresa!')
      }
    },

    selectTypeSearchCompany(searchInput) {
      this.paramsSeachCompany.idUsuario = this.usuarioLogado.basic.idUsuario
      if (this.isCpfOrCnpj(searchInput)) {
        this.paramsSeachCompany.cpfCnpj = searchInput
        this.paramsSeachCompany.idEmpresa = null
        this.paramsSeachCompany.fts = null
        return
      }
      if (this.isIdCompany(searchInput)) {
        this.paramsSeachCompany.idEmpresa = searchInput
        this.paramsSeachCompany.cpfCnpj = null
        this.paramsSeachCompany.fts = null
        return
      }
      this.paramsSeachCompany.fts = searchInput
      this.paramsSeachCompany.cpfCnpj = null
      this.paramsSeachCompany.idEmpresa = null
    },

    isCpfOrCnpj(value) {
      const onlyNumbers = value.replace(/\D/g, '')
      const isInterger = parseInt(onlyNumbers)
      const searchInputSize = onlyNumbers.length
      const isCnpjSize = searchInputSize === 14
      const isCPFSize = searchInputSize === 11
      const matchSize = isCPFSize || isCnpjSize
      return isInterger && matchSize
    },

    isIdCompany(value) {
      const onlyNumbers = value.replace(/\D/g, '')
      const isInterger = parseInt(onlyNumbers)
      const searchInputSize = onlyNumbers.length
      const isIdSize = searchInputSize < 11
      return isInterger && isIdSize
    },

    async getEmpresaInfo(empresa) {
      this.$store.dispatch('setCompany', empresa)
      try {
        const { body } = await EmpresaService.pesquisaCompletaEmpresa({ idEmpresa: empresa.id })
        this.$store.dispatch('setCompany', body)
        this.empresas = []
      } catch (error) {
        console.error(error)
      }
    }
  },
  components: {
    Multiselect,
    Modal,
    EmpresaDetalhes,
    EmpresaPendencias
  },
  computed: {
    empresaSelecionada: {
      get() {
        return this.$store.getters.getCompany
      },
      set(val) {}
    },

    usuarioLogado() {
      return this.$store.getters.getUser
    }
  }
}
</script>

<style scoped="">
.inline-components {
  display: inline;
}

.hidden-when-reaches-minwidth {
  text-align: center;
  padding: 0;
}

.max-screen {
  padding: 10px 0 0 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media only screen and (max-width: 768px) {
  .hidden-when-reaches-minwidth {
    display: none;
  }
}

@media only screen and (max-width: 1366px) {
  div .col-sm-2.max-screen {
    padding-top: 12px;
  }
}

::v-deep .multiselect__option {
  font-size: 12px;
}

::v-deep .multiselect__single {
  font-size: 12px;
}

::v-deep .multiselect__input {
  font-size: 12px;
}

::v-deep .multiselect__placeholder {
  font-size: 12px;
}

</style>
